import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import GoogleAds from './components/GoogleAds';
import Projects from './components/Projects';
import HowWeWork from './components/HowWeWork';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import WhatsAppWidget from './components/WhatsAppWidget';
import CookieConsent from './components/CookieConsent';
import AIVideoService from './pages/AIVideoService';
import AdvertVideoMaker from './pages/AdvertVideoMaker';
import PodcastService from './pages/PodcastService';
import OpportunitiesPage from './pages/OpportunitiesPage';
import AffiliatePage from './pages/AffiliatePage';
import ImpressumPage from './pages/ImpressumPage';
import PrivacyPage from './pages/PrivacyPage';

const NotFoundPage = () => (
  <main className="pt-36 pb-24 bg-white">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <p className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">404</p>
      <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-6">Page not found</h1>
      <p className="text-slate-600 font-medium mb-10">Sorry, this page does not exist.</p>
      <a href="/" className="inline-flex px-6 py-3 rounded-full bg-emerald-600 text-white font-bold hover:bg-emerald-700 transition-colors">
        Go to the home page
      </a>
    </div>
  </main>
);

const ScrollToSection = ({ sectionId }) => {
  const location = useLocation();

  useEffect(() => {
    if (!sectionId) return undefined;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);

      if (element) {
        const offset = 80;
        const position =
          element.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: position,
          behavior: 'smooth',
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [sectionId, location.pathname]);

  return null;
};

const HomePage = ({ sectionId }) => (
  <main>
    <ScrollToSection sectionId={sectionId} />
    <Hero />
    <Services />
    <GoogleAds />
    <Projects />
    <HowWeWork />
    <About />
    <ContactCTA />
    <FAQ />
    <Contact />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white font-sans text-slate-900">
        <Navbar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<HomePage sectionId="services" />} />
          <Route
            path="/ads-strategy"
            element={<HomePage sectionId="ads-strategy" />}
          />
          <Route
            path="/google-ads"
            element={<HomePage sectionId="ads-strategy" />}
          />
          <Route path="/projects" element={<HomePage sectionId="projects" />} />
          <Route path="/process" element={<HomePage sectionId="process" />} />
          <Route path="/about" element={<HomePage sectionId="about" />} />
          <Route path="/faq" element={<HomePage sectionId="faq" />} />
          <Route path="/opportunities" element={<OpportunitiesPage />} />
          <Route path="/affiliates" element={<AffiliatePage />} />
          <Route
            path="/ai-video-creation-service"
            element={<AIVideoService />}
          />
          <Route path="/advert-video-maker" element={<AdvertVideoMaker />} />
          <Route path="/ai-podcast-creation" element={<PodcastService />} />
          <Route path="/ai-video" element={<AIVideoService />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        <Footer />
        <WhatsAppWidget />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;
